export default function getEChartsNetworkAgeAtFirstObservation({
  zeroBaseline = false,
  data = [],
}) {
  const grouped = {};
  data.forEach((d) => {
    const source = d.DATA_SOURCE_KEY;
    if (!grouped[source]) grouped[source] = [];
    grouped[source].push({
      x: +d.INTERVAL_INDEX,
      y: +d.PERCENT_VALUE,
    });
  });

  Object.values(grouped).forEach((arr) => arr.sort((a, b) => a.x - b.x));

  const series = Object.entries(grouped).map(([source, values]) => ({
    name: source,
    type: "line",
    showSymbol: false,
    emphasis: { focus: "series" },
    data: values.map((d) => [d.x, d.y]),
  }));

  return {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "cross",
        label: {
          formatter: (params) => {
            if (params.axisDimension === "y") {
              return `${(params.value * 100).toFixed(0)}%`;
            }
            return `${params.value}`;
          },
        },
      },
      formatter: (params) => {
        const age = params[0].value[0];
        return (
          `Age: ${age}<br/>` +
          params
            .map(
              (p) =>
                `${p.marker}${p.seriesName}: ${(p.value[1] * 100).toFixed(2)}%`
            )
            .join("<br/>")
        );
      },
    },
    legend: {
      top: 0,
      type: "scroll",
    },
    grid: {
      left: 35,
      right: "2%",
      bottom: "10%",
      top: "10%",
      containLabel: true,
    },
    xAxis: {
      type: "value",
      name: "Age",
      nameLocation: "middle",
      nameGap: 25,
    },
    yAxis: {
      type: "value",
      name: "% of Population",
      nameLocation: "middle",
      nameGap: 50,
      axisLabel: {
        formatter: (v) => `${(v * 100).toFixed(0)}%`,
      },
      min: zeroBaseline ? 0 : undefined,
    },
    series,
  };
}
